import type { EventContentObjectDetail } from 'models';
import { useState } from 'react';
import { usePermissions } from 'permissions';
import { Button, Card, Icon, Space } from 'ui';
import { EventInviteesModal } from '../../components';
import { useEventRsvpLabels } from '../../hooks';
import { QuickInviteEventAttendees } from '../../QuickInviteEventAttendees';
import { EventAdmins } from './event-admins';
import { EventInvitees } from './event-invitees';

type ModalState = { type?: 'inviteMembers' | 'seeAll' | 'seeAllInviteMembers' };

type P = {
  eventContentObject: EventContentObjectDetail;
};

const ProgramEventDetailInvitees = ({ eventContentObject }: P) => {
  const [modalsOpen, setModalsOpen] = useState<ModalState>({});
  const { goingInviteesCount, id } = eventContentObject.event;
  const { canInviteRailsUserToEvent } = usePermissions();
  const { getAcceptedSectionTitle } = useEventRsvpLabels();

  // TODO: handle cases when there are no invitees or admins

  return (
    <>
      <Card
        extra={
          <Button
            onClick={() => {
              setModalsOpen({ type: 'seeAll' });
            }}
            type="link-primary"
          >
            See all
          </Button>
        }
        title={
          <Card.Title icon={<Icon icon="check-circle-line" />}>
            {getAcceptedSectionTitle({ count: goingInviteesCount })}
          </Card.Title>
        }
      >
        <Space block orientation="vertical" size="middle">
          <EventAdmins eventId={id} />
          <EventInvitees eventId={id} />

          {canInviteRailsUserToEvent({ contentObject: eventContentObject }) ? (
            <Button
              block
              icon={<Icon icon="user-add-line" />}
              onClick={() => {
                setModalsOpen({ type: 'inviteMembers' });
              }}
              type="secondary"
            >
              Invite
            </Button>
          ) : null}
        </Space>
      </Card>

      <EventInviteesModal
        eventContentObject={eventContentObject}
        isOpened={modalsOpen.type === 'seeAll' || modalsOpen.type === 'seeAllInviteMembers'}
        onClose={() => {
          setModalsOpen({ type: undefined });
        }}
        onOpenInviteModal={() => {
          setModalsOpen({ type: 'seeAllInviteMembers' });
        }}
        visuallyHidden={modalsOpen.type === 'seeAllInviteMembers'}
      />

      <QuickInviteEventAttendees
        eventId={id}
        isOpened={modalsOpen.type === 'inviteMembers' || modalsOpen.type === 'seeAllInviteMembers'}
        onCancel={() => {
          setModalsOpen({ type: undefined });
        }}
        onSuccess={() => {
          setModalsOpen({
            type: modalsOpen.type === 'inviteMembers' ? undefined : 'seeAll',
          });
        }}
      />
    </>
  );
};

export default ProgramEventDetailInvitees;
